import React, { useCallback, useState } from 'react';
// import PlatformWrapper from '../platform-wrapper';
import { SearchOutlined } from '@ant-design/icons';
import './index.less';
import { Spin, message, Input, Dropdown, Menu } from 'antd';
import apis from '@/apis/global';
import { debounce } from 'lodash';
import { SearchMsgIcon } from 'src/pages/all-about-me/activity-message-center/components/message-center-modal/msg-icon';

// import IconTip from '@/components/icon-tip';

const processData = (data: any, value: string) => {
  if (data?.resultType === '') return [];
  const jumpMap: { [propName: string]: any } = {
    THEME_01: {
      name: data.themeActivtyName,
      href: `/activity-manage/merchants/detail/info?planCode=${data.themeActivtyId}`,
    },
    RESOURCE_01: {
      name: data.activityName,
      href: `/platform-marketing/resource-detail/material-collection/distribute/roomlist?channelId=${data.channelId}&resourceId=${data.resourceId}&activityId=${data.activityId}&entry=1&hideTab=1&id=${data.activityId}`,
      param: `blockid=${data.areaId}`,
    },
    RESOURCE_02: {
      name: data.activityName,
      href: `/channel-service/position/resource-detail/material-collection/distribute/roomlist?channelId=${data.channelId}&resourceId=${data.resourceId}&activityId=${data.activityId}&entry=1&hideTab=1&id=${data.activityId}`,
      param: `blockid=${data.areaId}`,
    },
    NORMAL_01: {
      name: data.activityName,
      href: `/activity-manage/myCreate/pools/roomlist?entry=1&activityId=${data.activityId}&from=acore&hideTab=1&id=${data.activityId}`,
      param: `blockid=${data.areaId}`,
    },
    NORMAL_02: {
      name: data.activityName,
      href: `/activity-manage/merchants/venueDetail/poolList?entry=1&planCode=${data.themeActivtyId}&roomId=${data.yxActivityId}&activityId=${data.activityId}&from=acore&hideTab=1`,
      param: `blockid=${data.areaId}`,
    },
    NORMAL_03: {
      name: data.activityName,
      href: `/activity-manage/myCreate/daily-activities-operation/pitEnroll/roomlist?entry=1&activityId=${data.activityId}&from=acore&hideTab=1&id=${data.activityId}`,
      param: `blockid=${data.areaId}`,
    },
    UNITED_01: {
      name: data.activityName,
      href: `/activity-manage/myCreate/zongcuActivity/myJoin/detail/activityEnroll/detail?activity_id=${data.unitedShortNumber}`,
    },
    UNITED_02: {
      name: data.activityName,
      href: `/activity-manage/merchants/detail/promotion/myJoin/detail/activityEnroll/detail?activity_id=${data.unitedShortNumber}&planCode=${data.themeActivtyId}&tab_key=2`,
    },
    UNITED_03: {
      name: data.activityName,
      href: `/platform-marketing/${data.channelId}/cuxiao-play-and-detail/activityEnroll/detail?activity_id=${data.unitedShortNumber}&tab_key=2`,
    },
    UNITED_04: {
      name: data.activityName,
      href: `/channel-service/position/${data.channelId}/cuxiao-play-and-detail/activityEnroll/detail?activity_id=${data.unitedShortNumber}&tab_key=2`,
    },
    STOCK_TAKING_01: {
      name: data.activityName,
      href: `/ph/phActivityDetail/enroll/signUp?id=${data.activityId}`,
    },
  };
  interface resType {
    name?: string;
    href?: string;
    param?: string;
    value?: any;
  }
  let res: resType[] = [];
  if (jumpMap[data.resultType]) {
    res = [{ ...jumpMap[data.resultType], value: value }];
  }
  if (data.hitType === 'TIBAO_AREA_ID') {
    res[0].name = data.areaName;
    if (res[0].param) {
      res[0].href = res[0].href + '&' + res[0].param;
    }
  }

  return res;
};

function GlobalSearch() {
  const [result, setResult] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const onBlurHandle = useCallback(() => {
    setTimeout(() => {
      setVisible(false);
    }, 200);
  }, []);
  //@ts-ignore
  const getResult = debounce((value) => {
    setLoading(true);
    apis.search({ keyword: value }).then(({ ret, msg, data }) => {
      if (ret === '0') {
        setResult(processData(data, value));
      } else {
        message.error(msg);
        setResult([]);
      }
      setLoading(false);
    });
  }, 500);
  const handleSearch = (e: any) => {
    setInputValue(e.target.value);
    if (e.target.value) {
      getResult(e.target.value);
    } else {
      setResult([]);
    }
  };

  // 埋点
  const log = (val: string) => {
    const param = JSON.stringify({ activityid: val });
    (window as any).log('yx_center', 'workbenchsearch', param);
  };

  // 优化
  return (
    <div>
      {/* <PlatformWrapper
        title={
          <div>
            活动报名编号搜索
            <IconTip
              title="为方便您更高效的进行活动报名，需报名的主题活动、会场/促销/收品活动、频道资源位可用编号进行全局搜索哦！目前暂不支持搜索“我管理的”活动 ，如需查找请您前往对应活动列表~"
              type="question"
            />
          </div>
        }
        hasMore={false}
        background="#FFFFFF"
      > */}
      <div
        id="global-search"
        className="global-search"
        onMouseLeave={onBlurHandle}
        onMouseEnter={() => {
          setVisible(true);
        }}
      >
        <div className="global-search__search-icon">
          {' '}
          <SearchMsgIcon />
        </div>
        <Dropdown
          visible={visible}
          getPopupContainer={() => document.getElementById('global-search-ing') as HTMLElement}
          overlay={
            loading ? (
              <Menu>
                <div className="global-search__content">
                  <Spin size="small" />
                </div>
              </Menu>
            ) : result.length === 0 ? (
              <Menu>
                <div className="global-search__content">{!!inputValue ? '暂无相关可报活动' : '请输入活动编号搜索'}</div>
              </Menu>
            ) : (
              <Menu>
                {result.map((item: any, key: any) => (
                  <Menu.Item
                    key={item.value}
                    onClick={() => {
                      log(item.value);
                      window.open(result[0].href);
                      setVisible(false);
                    }}
                  >
                    <div style={{ padding: '12px 16px' }}>{item.name}</div>
                  </Menu.Item>
                ))}
              </Menu>
            )
          }
        >
          <Input
            style={{ paddingLeft: '36px' }}
            onChange={handleSearch}
            onFocus={() => {
              setVisible(true);
            }}
            // onBlur={onBlurHandle}
            allowClear
            placeholder="输入主题活动、会场/促销/收品活动、资源位编号进行搜索"
          />
        </Dropdown>
      </div>
      <div id="global-search-ing"></div>
      {/* </PlatformWrapper> */}
    </div>
  );
}

export default GlobalSearch;
